import { Controller } from "@hotwired/stimulus"

// IngestDialog di pages/Grants.js: al 30° giro del sondaggio senza esito (poll:scaduto dal frame ingest-{id}) il frame
// si rilegge con scaduto=1: lettura non più in corso e il toast «Ingestione troppo lunga, riprova».
export default class extends Controller {
  static values = { scaduto: String }

  // Invio nel campo della pagina: nell'originale nessun form, quindi nessun avvio implicito.
  senzaInvio(event) {
    event.preventDefault()
  }

  scaduto(event) {
    const frame = event.target.closest("turbo-frame")
    if (frame) frame.src = this.scadutoValue
  }
}
